






























































































































import {Component, Prop, Vue} from "vue-property-decorator";
import moment from "moment";
import axios from "axios";
import parser from "fast-xml-parser";
import Swal from 'sweetalert2'

@Component({name: "Formulario"})
export default class FormularioContacto extends Vue {

  // Public PROPS
  @Prop() model  ?: string
  @Prop() title  ?: string
  @Prop() origin ?: "";
  @Prop() interes ?: "";
  @Prop() version ?: "";

  mounted(){
  }

  // changed to versions
  get versions(): any {
    let v = this.vehicles.filter((i)=>{ return i.name == this.model })[0];
    if(v){
      return v.versions
    }else{
      return []
    }
  }

  // PROPS
  idprefix = "";
  comments = "";
  cf_version = "";

  // FROM DATA
  terms = false;
  vehicles = [
    {
      name: "CIAZ2021",
      versions: [          
        {name: "GLX", transmisions: ["Automático"] },          
      ]
    },
    {
      name: "CIAZ",
      versions: [
        {name: "GLS", transmisions: ["Automático", "Manual"] },
        {name: "GLX", transmisions: ["Automático", "Manual"] },
        {name: "RS", transmisions: ["Automático", "Manual"] },
      ]
    },



     {
      name: "BALENO",
      versions: [
        {name: "GLS", transmisions: ["Automático", "Manual"] },
        {name: "GLX", transmisions: ["Automático", "Manual"] },
      ]
    },
    

    {
      name: "SWIFT BOOSTERGREEN",
      versions: [
        {name: "GLS", transmisions: ["Manual"] },
        {name: "GLX", transmisions: ["Manual"] },
      ]
    },

    {
      name: "ERTIGA BOOSTERGREEN",
      versions: [
        {name: "GLS", transmisions: ["Automatico","Manual"] },
        {name: "GLX", transmisions: ["Automatico","Manual"] },
      ]
    },

    {
      name: "IGNIS",
      versions: [
        {name: "GL", transmisions: ["Manual", "CVT"] },
        {name: "GLX", transmisions: ["Manual", "CVT"] },
      ]
    },
    {
      name: "IGNIS2021",
      versions: [
        {name: "GL", transmisions: ["Manual", "CVT"] },
        {name: "GLX", transmisions: ["Manual", "CVT"] },
      ]
    },
    /**{
      name: "ERTIGA",
      versions: [
        {name: "GLS", transmisions: ["Automático"] },
        {name: "GLX", transmisions: ["Automático"] },
      ]
    },**/
    {
      name: "ERTIGA XL7",
      versions: [
        {name: "XL7", transmisions: ["Automático"] }
      ]
    },
    {
      name: "S-CROSS",
      versions: [
        {name: "GLX", transmisions: ["Automático"]},
        {name: "BOOSTERJET", transmisions: ["Automático"]},
      ]
    },
    {
      name: "SWIFT",
      versions: [
        {name: "GLS", transmisions: ["Manual", "CVT"]},
        {name: "GLX", transmisions: ["Manual", "CVT"]},
        {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
      ]
    },
    {
      name: "SWIFT2021",
      versions: [
        {name: "GLS", transmisions: ["Manual", "CVT"]},
        {name: "GLX", transmisions: ["Manual", "CVT"]},
        {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
      ]
    },
    {
      name: "SWIFT-SPORT",
      versions: [
        {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
      ]
    },
    {
      name: "SWIFT-SPORT2021",
      versions: [
        {name: "BOOSTERJET", transmisions: ["Manual", "Automático"]},
      ]
    },
    {
      name: "JIMNY",
      versions: [
        {name: "GLX", transmisions: ["Manual", "Automático"]},
      ]
    },
    {
      name: "GRAND VITARA BOOSTERGREEN",
      versions: [
        {name: "GLX", transmisions: ["Automático"]},
      ]
    },
    {
      name: "FRONX BOOSTERGREEN",
      versions: [
        {name: "GLX", transmisions: ["Automático"]},
      ]
    },
    {
      name: "ERTIGA XL7 BOOSTERGREEN",
      versions: [
        {name: "GLX", transmisions: ["Automático"]},
      ]
    },
    {
      name: "NUEVO SWIFT BOOSTERGREEN",
      versions: [
        {name: "GLS", transmisions: ["Manual", "CVT"] },
        {name: "GLX", transmisions: ["Manual", "CVT"] },
      ]
    },

  ]
  horario_contacto : string = "9:00";
  f = {
    customer: {
      name: "",
      email: "",
      telefono: "",
      colonia: ""
    },
    vehicle: {
      year: "2020",
      transmision: ""
    },
  }

  // public versions : any = [];
  public transmisions : any = [];
  public sending : boolean = false;

  public validForm(){
    return this.f.customer.name != "" &&
      this.f.customer.email &&
      this.f.customer.telefono &&
      this.model &&
      this.cf_version &&
      this.f.vehicle.transmision;
  }

  // public setVersions(){
  //   this.cf_versions = this.vehicles.filter((i)=>{ return i.name == this.model })[0].versions
  // }

  public setTransmisions(){
    this.transmisions = this.vehicles.filter((i)=>{ return i.name == this.model })[0].versions.filter( (v) => {
      return v.name == this.cf_version
    })[0].transmisions;
  }

  public sendForm(ev:any){

    ev.preventDefault();

    if(!this.validForm()){
      // todo mensaje asegurate de llenar todos los campos
      return;
    }

    let idlead = "";
    if(this.idprefix){
      idlead = "SDW-"+this.idprefix+Date.now();
    }else{
      idlead = "SDW-"+Date.now();
    };

    let requestdate = moment().format('YYYY:MM:DD HH:mm:ss');

    this.comments +=
      this.horario_contacto ? "Horario de contacto: "+this.horario_contacto+" " : "",
      this.interes ? "Interes: "+this.interes+" " : "",
      this.f.vehicle.transmision ? "Transmision: "+this.f.vehicle.transmision+" " : "";

      var xmlData = `<?xml version="1.0" encoding="UTF-8"?>
      <adf>
         <prospect status="new">
            <requestdate>${requestdate}</requestdate>
            <id>${idlead}</id>
            <vehicle interest="buy" status="new">
               <make>SUZUKI</make>
               <year>${this.f.vehicle.year}</year>
               <model>${this.model}</model>
               <trim>${this.cf_version}</trim>
               <transmision>${this.f.vehicle.transmision}</transmision>
               <colorcombination >
                 <interiorcolor></interiorcolor>
                 <exteriorcolor></exteriorcolor>
               </colorcombination>
            </vehicle>
            <customer>
               <contact>
                  <name part="full">${this.f.customer.name}</name>
                  <email>${this.f.customer.email}</email>
                  <phone>${this.f.customer.telefono}</phone>
               </contact>
               <origin>${this.interes}</origin>
               <comments>${this.comments}</comments>
               <address type="home">
                <city>${this.f.customer.colonia}</city>
                <postalcode></postalcode>
                <country>Pruebas</country>
               </address>
            </customer>
            <vendor>
               <id source="inovatix">097914</id>
               <vendorname>SUZUKI Zacatecas</vendorname>
               <city>Calz. Héroes de Chapultepec 1602, Heroes de Chapultepec, 98040 Zacatecas, Zac.</city>
            </vendor>
         </prospect>
         <provider>
            <name>inovatix</name>
         </provider>
      </adf>
    `;

      // TODO SWITCH PROD URL
      const ulrProd = 'https://www.sicopweb.com/interface/adf/add/prospect.xml'
      const urlTest =  'https://www.answerspip.com/interface/adf/add/prospect.xml'

      this.sending = true;
      axios.post( urlTest,
          xmlData,
          {headers:
                { 
                  'X-API-KEY': 'ZDFhNGE1MzBhYjljNzAwNjYxODg0ZmVmYzY3Y2FiZWM=',
                  'Content-Type': 'application/xml',
                }
          }).then( res => {

            this.sending = false;
            var xmlResponseString = res.data;
            var jsonResponse = parser.parse(xmlResponseString);
                Swal.fire({
                  title: 'Se ha envíado la información de manera correcta',
                  text: jsonResponse.adfresponselist.adfresponse.prospectstatus,
                  icon: 'success',
                  confirmButtonText: 'Ok'
                }).then( (r) => {
                  location.reload();
                })
            if(jsonResponse.adfresponselist.adfresponse.adfstatus == "Error"){
              Swal.fire({
                title: 'Error!',
                text: jsonResponse.adfresponselist.adfresponse.prospectstatus,
                icon: 'error',
                confirmButtonText: 'Ok'
              })
            }else{

            }

      }).catch( err => {

        // TODO SAVE LOG
        console.log(err);

      });


  }

}

